import { Injectable } from "@angular/core";
import { forkJoin, of, Observable } from "rxjs";
import { concatMap, map } from "rxjs/operators";
import { AppAppearanceData, AppAppearanceService } from "../../shared/services/app-appearance.service";
import { AuthService, AuthType } from "../../shared/services/auth.service";
import { UserService } from "../../shared/services/user.service";
import { IStemexeHost, IStemexeModule } from "../interfaces/interfaces";
import { DataProvider, PagedData, PagedDataItem } from "../models/models";
import { ProductsService } from "src/app/products/products.service";

@Injectable({
    providedIn: 'root'
})

export class StemexeDataProviderService implements IStemexeHost {
    type: AuthType = AuthType.Stemexe;
    private _stemexeClientModules: IStemexeModule[] = [];

    constructor(private auth: AuthService,
        private appearance: AppAppearanceService,
        private userService: UserService,
        private productsService: ProductsService) { }
    setPageWidth(width: "full" | "default" | "full-40p") {
        this.appearance.setPageWidth(width);
    }

    initialize(): void {
    }

    registerDataProvider(clientModule: IStemexeModule) {
        if (!this._stemexeClientModules.some(cm => cm.type.toLowerCase() == clientModule.type.toLowerCase())) {
            this._stemexeClientModules.push(clientModule)
            clientModule.initialize();
        }
    }

    getAuthorizationCode(clientId: string): Observable<string> {
        return this.auth.getIdenediAuthorizationCodeForClient(clientId);
    }
    getAppAppreanceInformation(): Observable<AppAppearanceData> {
        return this.appearance.getAppAppearanceData(this.auth.idenediGroupId);
    }
    getDataProviders(providerType: string): Observable<DataProvider[]> {
        const clientModulesDataProviders$ = this._stemexeClientModules.map(clientModule => clientModule.getDataProviders(providerType));
        return forkJoin(clientModulesDataProviders$).pipe(map(data => data.flat()));

    }
    openUrl(url: string, context: any): any {
        this._stemexeClientModules.forEach(clientModule => {
            clientModule.openUrl(url, context)
        });
    }

    disconnectDataProvider(type: AuthType) {
        this._stemexeClientModules = this._stemexeClientModules.filter(cm => cm.type.toLowerCase() !== type.toLowerCase());
    }

    disconnectAllDataProviders() {
        this._stemexeClientModules = [];
    }

    getGroupMembers(pageNumber: number = 1, pageSize: number = 20, searchQuery?: string): Observable<PagedData> {
        if (pageNumber < 1) {
            console.error('Page number must be greater than 0');
            return;
        }
        const skip = (pageNumber - 1) * pageSize;

        return this.userService.getMembers(searchQuery, skip, pageSize).pipe(
            map(resp => {
                let pagedData = new PagedData();
                if (resp.length < pageSize) {
                    pagedData.nextPageToken = false;
                } else {
                    pagedData.nextPageToken = true;
                }
                pagedData.items = resp.map(member => {
                    return {
                        id: member.Idenedi,
                        title: `${member?.Profile?.FirstName ?? ''} ${member?.Profile?.LastName ?? ''}`,
                        extraData: {
                            profileImageUrl: member?.Profile?.ProfileImageUrl,
                        },
                        url: '',
                        getData: () => of(new PagedData())
                    } as PagedDataItem;

                })
                return pagedData;
            })
        )
    }

    getTechnadoptTopics(search: {
        pageNumber: number,
        pageSize: number,
        searchQuery?: string
    }): Observable<PagedData> {
        if (!search) {
            throw Error('incorrect request parameters');
        }
        if (!search.pageNumber || search.pageNumber < 1) {
            search.pageNumber = 1;
        }
        if (!search.pageSize || search.pageSize < 1) {
            search.pageSize = 20;
        }
        const start = (search.pageNumber - 1) * search.pageSize;

        return this.productsService.getMyTopics({
            start: start,
            limit: search.pageSize,
            searchTerm: search.searchQuery ?? ''
        }).pipe(
            map(resp => {
                let pagedData = new PagedData();
                const pagination = resp.Paging[0]
                if (pagination.PageNumber * pagination.PageSize >= pagination.TotalCount) {
                    pagedData.nextPageToken = false;
                } else {
                    pagedData.nextPageToken = true;
                }
                pagedData.items = resp.Topics.map(topic => {
                    return {
                        id: topic.TopicId,
                        title: topic.TopicName,
                        extraData: {
                            ...topic
                        },
                        getData: () => of(new PagedData())
                    } as PagedDataItem;

                })
                return pagedData;
            })
        )
    }

}




